const DASHBOARD_NAME_UPDATED = (state, name) => {
  state.name = name;
};

const SET_SHOW_PER_PAGE = (context, { key, perPage }) => {
  context.showPerPage[key] = perPage;
};

const INITIALISE_STORE = (state, { key, perPage }) => {
  const storeKey = `${key}-emails-per-page`;

  if (localStorage.getItem(storeKey) !== null
    && Number.isInteger(parseInt(localStorage.getItem(storeKey), 10))) {
    state.showPerPage[key] = parseInt(localStorage.getItem(storeKey), 10);
  } else {
    state.showPerPage[key] = perPage;
  }
};

export default {
  DASHBOARD_NAME_UPDATED,
  SET_SHOW_PER_PAGE,
  INITIALISE_STORE,
};
